import React from 'react';
import './subscription-offer-shimmer.m.css';

const SubscriptionOfferShimmer = () => {
  return (
    <div styleName="subscription-offer-shimmer">
      <div styleName="shimmer-banner">
        <div styleName="subscription-card">
          <div styleName="shimmer-card">
            <div styleName="icon"></div>
            <div styleName="heading"></div>
            <div styleName="exp-text"></div>
            <div styleName="exp-date"></div>
            <div styleName="back-btn"></div>
          </div>
        </div>
      </div>
      <div style={{ height: '81px' }} className="desktop-only"></div>
      <div styleName="divider-outer"></div>
      <div styleName="benifit">
        {new Array(6).fill(null).map((_, i) => (
          <div styleName="card" key={i}></div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionOfferShimmer;
